import React from 'react'
import './index.scss'
import App from './App'
import * as serviceWorker from './serviceWorker'
import { isClipspecMode, isWholesalerMode } from './wholesaler-integration/isWholesalerMode'
import { WholesalerIntegrationAppWrapper } from './wholesaler-integration/WholesalerIntegrationAppWrapper'
import { ClipspecAppWrapper } from './clipspec-integration/ClipspecAppWrapper'
import { createRoot } from 'react-dom/client'
import { throwInline } from './utils/throwErrorInline'

const root = createRoot(document.getElementById('root') ?? throwInline(Error('root element not found')))

if (isWholesalerMode()) {
  root.render(<WholesalerIntegrationAppWrapper />)
} else if (isClipspecMode()) {
  root.render(<ClipspecAppWrapper />)
} else {
  root.render(<App />)
}


// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister()
